import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

export default function PersonPlusIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 31 31">
      <path
        d="M23 14.25h-2.5a1.2 1.2 0 0 1-.89-.36 1.2 1.2 0 0 1-.36-.89q0-.531.36-.89.359-.36.89-.36H23v-2.5q0-.531.36-.89.359-.36.89-.36t.89.36.36.89v2.5H28q.531 0 .89.36.36.359.36.89t-.36.89-.89.36h-2.5v2.5q0 .531-.36.89-.359.36-.89.36a1.2 1.2 0 0 1-.89-.36 1.2 1.2 0 0 1-.36-.89zM11.75 15.5q-2.062 0-3.531-1.469-1.47-1.468-1.469-3.531 0-2.062 1.469-3.531T11.75 5.5t3.531 1.469q1.47 1.469 1.469 3.531t-1.469 3.531T11.75 15.5m-10 7.5v-1q0-1.063.547-1.953a3.65 3.65 0 0 1 1.453-1.36 18.6 18.6 0 0 1 3.938-1.453 17.2 17.2 0 0 1 4.062-.484q2.063 0 4.063.484a18.6 18.6 0 0 1 3.937 1.453 3.65 3.65 0 0 1 1.453 1.36q.547.891.547 1.953v1q0 1.032-.734 1.766t-1.766.734h-15a2.4 2.4 0 0 1-1.766-.734A2.4 2.4 0 0 1 1.75 23"
        fill="currentColor"
      />
    </BaseIcon>
  )
} 